import { render } from "./List.vue?vue&type=template&id=264bddce&scoped=true"
import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"

import "./List.vue?vue&type=style&index=0&id=264bddce&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264bddce"],['__file',"src/components/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "264bddce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('264bddce', __exports__)) {
    console.log('reload')
    api.reload('264bddce', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=264bddce&scoped=true", () => {
    console.log('re-render')
    api.rerender('264bddce', render)
  })

}


export default __exports__